import template from './usersBrands.html';
import './usersBrands.scss';

export class UsersBrandsController {
  constructor() {
    this.searchQuery = '';
    this.brandsList = [];
    this.selectedBrands = {};
    this.toggleAll = true;
    this.disableToggle = false;
    this.disableBulkActions = false;
  }
  handleHeaderAction(action) {
    this.onHeaderActionClicked({ action });
  }
  setSearchQuery(text) {
    this.searchQuery = text.toLowerCase();
    this.filterBrands();
  }
  filterBrands(resetSelection = false) {
    if (resetSelection) {
      this.copySelectionList();
    }

    if (this.searchQuery) {
      this.brandsList = this.brands.filter(({
        name,
        photorank_id: photorankId,
      }) => name.toLowerCase().includes(this.searchQuery) ||
        photorankId.toString().toLowerCase().includes(this.searchQuery));
    } else {
      this.brandsList = this.brands || [];
    }

    this.updateToggleFlags();
  }
  copySelectionList() {
    this.selectedBrands = {};
    this.brandsList.forEach((brand) => {
      this.selectedBrands[brand.id] = false;
    });
  }
  updateToggleFlags() {
    this.disableToggle = !this.brandsList.length;
    if (this.disableToggle) {
      this.toggleAll = true;
    } else {
      const halfDivider = 2;
      const half = Math.round(this.brandsList.length / halfDivider);
      const selected = Object.keys(this.selectedBrands)
      .filter((brandId) => this.selectedBrands[brandId])
      .length;
      this.toggleAll = selected < half;
      this.disableBulkActions = !selected;
    }
  }
  toggleList(select) {
    this.selectedBrands = {};
    this.toggleAll = !this.toggleAll;
    if (select) {
      this.brandsList.forEach((brand) => {
        this.selectedBrands[brand.id] = true;
      });
    }

    this.updateToggleFlags();
  }
  revokeSelected() {
    this.onRevoke({ brands: this.getSelectedBrands() });
  }
  revoke(brand) {
    this.onRevoke({ brands: [brand] });
  }
  updateSelected() {
    this.onUpdate({ brands: this.getSelectedBrands() });
  }
  update(brand) {
    this.onUpdate({ brands: [brand] });
  }
  view(brand) {
    this.onView({ brand });
  }
  getSelectedBrands() {
    const ids = Object.keys(this.selectedBrands)
    .filter((brandId) => this.selectedBrands[brandId]);

    return this.brandsList.filter((brand) => ids.includes(brand.id));
  }
  $onChanges({ user, loading }) {
    if (
      user &&
      user.previousValue.id !== user.currentValue.id
    ) {
      this.searchQuery = '';
    }

    if (loading && loading.previousValue && !loading.loadingCurrentValue) {
      this.filterBrands(true);
    }
  }
}

export default {
  controller: UsersBrandsController,
  template,
  bindings: {
    user: '<',
    brands: '<',
    loading: '<',
    headerActions: '<',
    subMenu: '<',
    onHeaderActionClicked: '&',
    canUpdatePermissions: '<',
    onView: '&',
    onRevoke: '&',
    onUpdate: '&',
  },
  transclude: {
    roleSelector: 'usersBrandsRoleSelector',
  },
};
